import { gql } from "graphql-request";

const SERVER_UPDATE_USER_STATUS = gql`
  mutation SERVER_UpdateUserStatus($userId: ID!, $status: UserStatus!) {
    updateUserStatus(userId: $userId, status: $status)
  }
`;
export default SERVER_UPDATE_USER_STATUS;
